// extracted by mini-css-extract-plugin
module.exports = {"container":"Page-module--container--2JgeL"};